import styled from 'styled-components';

const StyledMedicalLeaveFormInsurer = styled.div`
   max-width: 250px;
`;
StyledMedicalLeaveFormInsurer.displayName = 'StyledMedicalLeaveFormInsurer';

export { StyledMedicalLeaveFormInsurer };
